import {
  TABLE_DATA_GET_REQUEST,
  TABLE_DATA_GET_SUCCESS,
  TABLE_DATA_GET_FAILURE,
  LOGIN_SUCCESS,
  TABLE_SEARCH_PARAMS_CLEAR,
  TABLE_SEARCH_PARAMS_UPDATE,
} from '../../actions/constants/types';

export const initialSearchResultsState = {
  isFetching: false,
  items: [],
  pages: 0,
};

function tableReducer(state = {}, action) {
  switch (action.type) {
    case TABLE_DATA_GET_REQUEST: {
      const searchResults =
        state[action.reduxIdentifier] && state[action.reduxIdentifier].searchResults
          ? {
              ...state[action.reduxIdentifier].searchResults,
              isFetching: true,
            }
          : {
              ...initialSearchResultsState,
              isFetching: true,
            };
      const previousTableState = state[action.reduxIdentifier]
        ? {
            ...state[action.reduxIdentifier],
          }
        : {};
      return {
        ...state,
        [action.reduxIdentifier]: {
          ...previousTableState,
          searchResults,
        },
      };
    }
    case TABLE_DATA_GET_SUCCESS: {
      const previousTableState = state[action.reduxIdentifier]
        ? {
            ...state[action.reduxIdentifier],
          }
        : {};
      return {
        ...state,
        [action.reduxIdentifier]: {
          ...previousTableState,
          searchResults: {
            isFetching: false,
            items: action.response.data[action.responseObjectName ? action.responseObjectName : action.reduxIdentifier],
            pages: action.response.data.pages,
          },
        },
      };
    }
    case TABLE_SEARCH_PARAMS_CLEAR:
    case TABLE_DATA_GET_FAILURE: {
      const previousTableState = state[action.reduxIdentifier]
        ? {
            ...state[action.reduxIdentifier],
          }
        : {};
      return {
        ...state,
        [action.reduxIdentifier]: {
          ...previousTableState,
          searchResults: initialSearchResultsState,
          searchParams: action.initialSearchParams,
        },
      };
    }
    case TABLE_SEARCH_PARAMS_UPDATE: {
      const previousTableState = state[action.reduxIdentifier]
        ? {
            ...state[action.reduxIdentifier],
          }
        : {};
      const searchParams =
        state[action.reduxIdentifier] && state[action.reduxIdentifier].searchParams
          ? {
              ...action.initialSearchParams,
              ...state[action.reduxIdentifier].searchParams,
              ...action.params,
            }
          : {
              ...action.initialSearchParams,
              ...action.params,
            };
      return {
        ...state,
        [action.reduxIdentifier]: {
          ...previousTableState,
          searchParams,
        },
      };
    }
    case LOGIN_SUCCESS:
      return {};
    default:
      return state;
  }
}

export default tableReducer;
